//
import ProductModel from '@/models/Warehouse/WhProduct'
import ProductServiceModel from '@/models/Warehouse/WhProductService'
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

//
import DetailPurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/PchDetailPurchaseOrderHeaders'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import ProductServiceFilters from '@/views/Warehouse/WhProductService/WhProductServiceFilters'
import ProductServiceHeaders from '@/views/Warehouse/WhProductService/WhProductServiceHeaders'
import PurchaseOrderFilters from '@/views/Purchase/PchPurchaseOrder/list/filters'
import PurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/list/headers'

//
import { PurchaseOrderDetailHeaders } from '@/views/Purchase/PchPurchaseOrder/update/headers'

//
import { required } from '@/services/validations'

/**
 * @description
 * Parser of selected collection 'pch_selected_purchase_orders'
 *
 * @param      {object}  props   properties
 * @return     {DetailPurchaseOrder}  detail purchase order class
 */
const selected_parser = props => row => row.toDetailPurchaseOrder({ 
    g_branch_office_id: props.g_branch_office_id
})

//
export default (props) => [
    {
        name: 'purchase_order',
        title: 'Seleccionar orden de compra autorizada',
        fields: [
            {
                name: 'pch_selected_purchase_order',
                type: 'data-table-model',
                flex: {
                    'pt-0': true,
                    xs12: true,
                    'd-grid': true,
                },
                props: {
                    checkable: true,
                    class: 'v-card elevation-2 mb-4',
                    filters: PurchaseOrderFilters,
                    headers: PurchaseOrderHeaders,
                    noActions: true,
                    noDataText: 'Sin ordenes de compra autorizadas.',
                    noExport: true,
                    noHelper: true,
                    paramFilter: {
                        pch_purchase_order_state_id: 3,
                    },
                    rules: [required],
                    selectedOne: true,
                    service: PurchaseOrderModel,
                },
            },
        ],
    },
    {
        name: 'purchase_order_detail',
        title: 'Editar detalle de orden de compra',
        fields: [
            {
                name: 'pch_selected_purchase_order_detail',
                type: 'data-table-model',
                flex: {
                    'pt-0': true,
                    xs12: true,
                    'd-grid': true,
                },
                props: {
                    checkable: true,
                    checkableOne: true,
                    class: 'v-card elevation-2 mb-4',
                    headers: props.is_service ? DetailPurchaseOrderHeaders.forService : DetailPurchaseOrderHeaders.forProduct,
                    noActions: true,
                    noDataText: 'Sin productos.',
                    noExport: true,
                    noHelper: true,
                    noPagination: true,
                    noFilter: true,
                    noSearch: true,
                    pickerProps: {
                        attachParams: {
                            pch_provider_id: props.pch_provider_id,
                        },
                        filters: ProductFilters,
                        headers: props.is_service ? ProductServiceHeaders : ProductHeaders.exclude(['wh_item_is_inventoriable', 'is_repackaged']),
                        parser: selected_parser(props),
                        submitText: 'confirmar selección',
                        mapperFilter: filters => ({
                            ...filters,
                            product_provider_code: props.pch_provider_id && filters.product_provider_code ? `${props.pch_provider_id},${filters.product_provider_code}` : undefined
                        }),
                        service: props.is_service ? ProductServiceModel : ProductModel,
                        noPagination: false,
                        showNativePagination: false,
                        title: 'Seleccionar productos',
                    },
                    rules: [required],
                    showNativePagination: true,
                    showPicker: true,
                    toolbarColor: 'primary',
                    toolbarDark: true,
                    toolbarDense: true,
                    toolbarTitle: 'Detalle de orden de compra seleccionada',
                },
            },
        ],
    },
]
